/* eslint-disable import/prefer-default-export */
export const localStorageKeys = {
  pocket: {
    POCKET: 'pocket',
    POCKET_ACCOUNT: 'pocketAccount',
  },
  MENU_SHOW: 'menuShow',
  settings: {
    adviserAudio: 'adviserAudio',
    adviserVoice: 'adviserVoice',
  },
  signer: {
    confirmation: 'cyb:confirmation',
  },
};
